import { useMutation } from "@apollo/react-hooks";

import { InstructorDetails } from "../types";
import updateInstructorDetails from "../graph-ql/updateInstructorDetails.graphql";

const useMutationUpdateInstructorDetails = ({
  onCompleted,
}: {
  onCompleted: (data: { updateInstructor?: InstructorDetails }) => void;
}) =>
  useMutation(updateInstructorDetails, {
    onCompleted,
  });

export default useMutationUpdateInstructorDetails;
